import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "simple-line-icons/css/simple-line-icons.css";
import "./styles/index.less";
const originalWarn = console.warn;
console.warn = function(message, ...optionalParams) {
    if (message.includes("async-validator")) {
      return; // Ignore async-validator warnings
    }
    originalWarn.apply(console, [message, ...optionalParams]);
  };
ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
